import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { getResolvedAttributes } from '@atlaskit/link-analytics/resolved-attributes';
import { ASSETS_LIST_OF_LINKS_DATASOURCE_ID, JIRA_LIST_OF_LINKS_DATASOURCE_ID } from '@atlaskit/link-datasource';
import { pluginKey } from './pm-plugins/plugin-key';
export var appearanceForNodeType = function appearanceForNodeType(spec) {
  if (spec.name === 'inlineCard') {
    return 'inline';
  } else if (spec.name === 'blockCard') {
    return 'block';
  } else if (spec.name === 'embedCard') {
    return 'embed';
  }
  return;
};
export var selectedCardAppearance = function selectedCardAppearance(state) {
  if (state.selection instanceof NodeSelection) {
    return appearanceForNodeType(state.selection.node.type);
  }
};
export var titleUrlPairFromNode = function titleUrlPairFromNode(node) {
  var attrs = node.attrs;
  return {
    url: attrs.url || attrs.data && attrs.data.url,
    title: attrs.data && attrs.data.title
  };
};

/**
 * Merges the title and url from attributes and CardInfo from the resolved view, preferring the CardInfo.
 * @param titleUrlPair title and url information from the node attributes
 * @param info information stored in state from the resolved UI component view
 */
export var mergeCardInfo = function mergeCardInfo(titleUrlPair, info) {
  return {
    title: info && info.title || titleUrlPair.title,
    url: info && info.url || titleUrlPair.url
  };
};
export var displayInfoForCard = function displayInfoForCard(node, info) {
  return mergeCardInfo(titleUrlPairFromNode(node), info);
};
export var findCardInfo = function findCardInfo(state) {
  var pluginState = pluginKey.getState(state);
  if (!pluginState) {
    return undefined;
  }
  return pluginState.cards.find(function (cardInfo) {
    return cardInfo.pos === state.selection.from;
  });
};
var isAppearanceSupportedInParent = function isAppearanceSupportedInParent(currentNodePosition, editorState, fragment, currentAppearance) {
  var resolvedPosition = editorState.doc.resolve(currentNodePosition);
  var parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
  return parent && parent.type.validContent(fragment);
};
export var isEmbedSupportedAtPosition = function isEmbedSupportedAtPosition(currentNodePosition, editorState, currentAppearance) {
  return isAppearanceSupportedInParent(currentNodePosition, editorState, Fragment.from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
};
export var isBlockSupportedAtPosition = function isBlockSupportedAtPosition(currentNodePosition, editorState, currentAppearance) {
  return isAppearanceSupportedInParent(currentNodePosition, editorState, Fragment.from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
};
export var getResolvedAttributesFromStore = function getResolvedAttributesFromStore(url, display, store) {
  if (!store) {
    return {};
  }
  var urlState = store === null || store === void 0 ? void 0 : store.getState()[url];
  var displayCategory = display === 'url' ? 'link' : undefined;
  return getResolvedAttributes({
    url: url,
    displayCategory: displayCategory
  }, urlState === null || urlState === void 0 ? void 0 : urlState.details);
};
export var isDatasourceConfigEditable = function isDatasourceConfigEditable(datasourceId) {
  var datasourcesWithConfigModal = [JIRA_LIST_OF_LINKS_DATASOURCE_ID, ASSETS_LIST_OF_LINKS_DATASOURCE_ID];
  return datasourcesWithConfigModal.includes(datasourceId);
};